import hljs from 'highlight.js/lib/core';
import python from 'highlight.js/lib/languages/python';
import html from 'highlight.js/lib/languages/xml'; // Use xml for HTML highlighting
import css from 'highlight.js/lib/languages/css';
import 'highlight.js/styles/atom-one-light.css';

hljs.registerLanguage('python', python);
hljs.registerLanguage('html', html);
hljs.registerLanguage('css', css);

function HighlightCode() {

    function isHLJSEl(el) {
        return el.classList.contains('hljs');
    }

    function isHighlighted(el) {
        return el.classList.contains('hljs-highlighted');
    }

    // Highlight all pre > code blocks
    document.querySelectorAll('pre > code').forEach((el) => {
        if (isHLJSEl(el) && !isHighlighted(el)) {
            hljs.highlightElement(el);
            el.classList.add('hljs-highlighted');
        }
    });
}

export default HighlightCode;
